// Centralised analytics-consent gate backed by Termly.
// Default: DENIED.  Only flips to true once Termly confirms the user
// accepted the "analytics" category — matching the GA4 Consent Mode
// defaults already configured in public/index.html.

let analyticsGranted = false;

function applyPrefs(prefs) {
  if (!prefs || typeof prefs !== 'object') {
    analyticsGranted = false;
    return;
  }

  // Termly surfaces consent in several shapes depending on version:
  //   { analytics: true }
  //   { preferences: { analytics: true } }
  //   { categories: ['analytics', …] }
  //   { acceptedCategories: ['analytics', …] }
  if (prefs.analytics === true) { analyticsGranted = true; return; }
  if (prefs.preferences && prefs.preferences.analytics === true) { analyticsGranted = true; return; }
  if (Array.isArray(prefs.categories) && prefs.categories.includes('analytics')) { analyticsGranted = true; return; }
  if (Array.isArray(prefs.acceptedCategories) && prefs.acceptedCategories.includes('analytics')) { analyticsGranted = true; return; }

  analyticsGranted = false;
}

if (typeof window !== 'undefined') {
  window.addEventListener('userPrefUpdate', (e) => applyPrefs(e && e.detail));
  window.addEventListener('Termly.consentSaveDone', (e) => applyPrefs(e && e.detail));

  // Termly may already be loaded (returning visitor with stored consent).
  try {
    const api = window.Termly || window.termly;
    if (api && typeof api.getUserConsentStatus === 'function') {
      applyPrefs(api.getUserConsentStatus());
    }
  } catch (_) { /* safe to ignore */ }
}

export function isAnalyticsAllowed() {
  return analyticsGranted;
}
